import React, { useEffect, useState } from 'react'
import TextInput from '../../form/TextInput';
import { MenuItem } from '@mui/material';
import Button1 from '../../form/Button1';
import { enqueueSnackbar } from 'notistack';
import updateIntraverseCommission from '../../../controllers/SplitCommission/updateIntraverseCommission';
import addIntraverseCommission from '../../../controllers/SplitCommission/addIntraverseCommission';


export default function IntraverseCommissionForm({data: defData,close,callback}) {
    const [data,setData] = useState(defData || {
        "name": '',
        "commission": 0,
        "method": "" //Fixed, Percentage
    })
    const [loadings,setLoadings] = useState({submit: false})

    useEffect(() => {
        if(defData)
            setData(defData);
    },[defData])
    
    async function handleSubmit(ev) {
        ev?.preventDefault();
        const {_id,updated_at,created_at,status,...modData} = {...data,
            commission: Number(data?.commission)
        };
        setLoadings({...loadings,submit: true});
        let res = {return: 0, msg: '0XTAXFORM'};
        if(defData)
            res = await updateIntraverseCommission(_id,modData)
        else res = await addIntraverseCommission(modData);
        setLoadings({...loadings,submit: false});
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            callback && callback()
            close && close();
        } else enqueueSnackbar(res.msg,{variant: 'error'})

    }
    
  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-4 p-4'>
      <TextInput label='Name' value={data?.name} onChange={(ev) => setData({...data,name: ev.target.value})} />
      <TextInput label='Amount' type='number' value={data?.commission} onChange={(ev) => setData({...data,commission: ev.target.value})} />
      <TextInput select label='Method' value={data?.method} onChange={(ev) => setData({...data,method: ev.target.value})} >
        <MenuItem value='Percentage'>Percentage</MenuItem>
        <MenuItem value='Fixed'>Fixed</MenuItem>
      </TextInput>
      <div className='flex gap-4 items-center'>
        <div>
            {close ? 
                <Button1 variant='outlined' type='button' onCLick={() => close()}>Cancel</Button1>
            :null}
        </div>
        <Button1 loading={loadings?.submit} type='submit'>{defData ? 'Update' : `Add`}</Button1>
      </div>
    </form>
  )
}
